import { DOMSerializer, DOMParser } from "prosemirror-model";
import { EditorState } from "prosemirror-state";
import { EditorView } from "prosemirror-view";

import noop from "../lib/core/functional/noop";
import loadExternalStylesheet from "../utils/loadExternalStylesheet";

import getPlugins from "./plugins";
import getSchema from "./schema";

function getContainer() {
    const parent = document.createElement("div");
    parent.classList.add("rm-prosemirror-parent");
    const container = document.createElement("div");
    container.classList.add("rm-prosemirror-container");
    parent.appendChild(container);
    return [parent, container];
}

loadExternalStylesheet("/static/css-build/roar/runner/components/prosemirror.css", noop);

function getInitialContent(contentAsHtml) {
    const div = document.createElement("div");
    div.innerHTML = contentAsHtml;
    return div;
}

export default function getEditorView(settings) {
    const schema = getSchema();
    const plugins = getPlugins(schema, settings);

    const doc = DOMParser.fromSchema(schema).parse(
        getInitialContent(settings.initialContent || "")
    );

    const state = EditorState.create({
        schema,
        plugins,
        doc,
    });
    const [parent, container] = getContainer();
    const editor = new EditorView(container, { state });

    function getContent() {
        const fragment = DOMSerializer.fromSchema(schema).serializeFragment(
            editor.state.doc.content
        );
        const div = document.createElement("div");
        div.appendChild(fragment);
        return div.innerHTML;
    }

    function clear() {
        editor.updateState(
            EditorState.create({
                schema,
                plugins,
            })
        );
    }

    function disable() {
        editor.dom.contentEditable = false;
    }

    function enable() {
        editor.dom.contentEditable = true;
    }

    function destroy() {
        editor.destroy();
    }

    function getTextContent() {
        return editor.state.doc.textContent;
    }

    return {
        parent,
        container,
        editor,
        getContent,
        getTextContent,
        clear,
        enable,
        disable,
        destroy,
    };
}
